<template>
  <base-section-layout
    title="出签核对提醒"
    icon="https://pbs-public.oss-cn-shenzhen.aliyuncs.com/static-visa/pdv-www/order/order-interview-notification/section-visa-check.png"
  >
    <div class="section-text">
      签证出签后，请即刻<span class="c-red"
        >核对签证有效期（起止日期）、签证类型，以及姓名拼音、护照号、性别、出生日期、签证照片等个人信息</span
      >，确认所有内容与护照原件完全一致。信息不符请及时反馈，保障出行顺利。
    </div>
  </base-section-layout>
</template>

<script>
import BaseSectionLayout from './BaseSectionLayout.vue';

export default {
  name: 'SectionCheckReminder',
  components: {
    BaseSectionLayout,
  },
};
</script>

<style lang="less" scoped>
.section-text {
  color: #666;
  font-size: 12px;
  line-height: 21px;
  word-break: break-all;

  .c-red {
    color: #ff4b4d;
  }
}
</style>
